import {Component, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {ThemeOptions} from '../../../../../theme-options';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserBoxService } from './user-box.service';

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
})
export class UserBoxComponent implements OnInit {

  closeResult: string;
  newPassword="";
  adminName="";
  adminType="";
  confirmPassword="";
  constructor(public globals: ThemeOptions,
              private router:Router,
              private toastr:ToastrService,
              private modalService: NgbModal,
              private spinner:  NgxSpinnerService,
              private userBoxService:UserBoxService) {
  }

  ngOnInit() {
    let adminData = JSON.parse(sessionStorage.adminInformation);
    this.adminName = adminData.userName;
    this.adminType = adminData.adminType;
    this.newPassword = "";
  }

  update(){
    if(this.newPassword == this.confirmPassword){
      this.spinner.show();
      let adminInformation = JSON.parse(sessionStorage.getItem('adminInformation'))
      var sendData;
      if(this.newPassword){
        sendData = {
          id : adminInformation.id,
          userName : this.adminName,      
          adminType:this.adminType,
          password : this.newPassword,
        }
      }else{
        sendData = {
          id : adminInformation.id,
          userName : this.adminName,     
          adminType:this.adminType, 
        }
      }
      console.log(sendData)
      this.userBoxService.profileUpdate(sendData).subscribe((result:any)=>{
        console.log('profile update response  ',result);
        if(result.statusCode == 200){
          this.spinner.hide()
          this.toastr.success(result.message);
          sessionStorage.setItem('adminInformation' , JSON.stringify(result.data));
          this.adminName= result.data.userName;
          this.adminType = result.data.adminType;
          this.modalService.dismissAll()
        }else{
          this.spinner.hide()
          this.toastr.error(result.message);

        }
      })
    }else{
        this.toastr.error("Password does not match")
    }
  
   
  }



  logout(){
    this.toastr.success('Logout successfully');
    sessionStorage.clear()
    this.router.navigate(['pages/login-boxed'])
  }



  openModal(content) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.newPassword="";
    this.confirmPassword="";
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
